import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(['fi', () => {}]);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('fi');
  return (
    <LanguageContext.Provider value={[lang, setLang]}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    return ['fi', () => {}];
  }
  return context;
}
